const ENAuditsPanel = {
	"aberta": "open",
	"abertas": "open",
	"Adicionar Auditoria": "Add Audit",
	"Adicionar livre": "Add free",
	"Alterar Auditoria": "Change Audit",
	"Auditor Externo": "External Auditor",
	"Auditor Externo é requerido": "External Auditor is required",
	"Auditores não podem ser repetidos": "Auditors cannot be repeated",
	"Auditores externos não podem ser repetidos": "External auditors cannot be repeated",
	"Auditores": "Auditors",
	"Auditoria adicionada com sucesso": "Audit successfully added",
	"Auditoria alterada com sucesso": "Audit changed successfully",
	"Auditoria copiada com sucesso": "Audit copied successfully",
	"Auditoria excluída com sucesso": "Audit successfully deleted",
	"Auditoria executada com sucesso": "Audit performed successfully",
	"Categoria de Não Conforme": "Non-Compliant Category",
	"Categoria de Oportunidade de Melhoria": "Improvement Opportunity Category",
	"Categoria de Observação": "Note Category",
	"Códigos dos itens não podem ser repetidos": "Item code cannot be repeated",
	"concluída": "completed",
	"concluídas": "completed",
	"Conforme": "Conform",
	"Copiar Auditoria": "Copy Audit",
	"Data Planejada": "Planned Date",
	"Data Realizada": "Date Accomplished",
	"Data de alteração": "Change date",
	"Descrição dos itens não podem ser repetidos": "Description of items cannot be repeated",
	"Deseja realmente excluir a auditoria": "Do you really want to delete the audit",
	"Deseja realmente executar a auditoria?": "Do you really want to run the audit?",
	"Digite o título da auditoria para excluí-lo": "Enter the audit title to delete it",
	"em auditoria": "in audit",
	"Em Auditoria": "In Audit",
	"Erro ao carregar as auditorias": "Error loading audits",
	"Erro ao carregar a auditoria": "Error loading audit",
	"Erro ao adicionar auditoria": "Error adding audit",
	"Erro ao alterar auditoria": "Error changing audit",
	"Erro ao atualizar contadores": "Error updating counters",
	"Erro ao atualizar auditoria, favor atualizar a pagina": "Error updating audit, please refresh the page",
	"Erro ao excluir auditoria": "Error deleting audit",
	"Erro ao executar auditoria": "Error running audit",
	"Executar Auditoria": "Run Audit",
	"Externa": "External",
	"Externas": "External",
	"Exclusão de Auditoria": "Audit Exclusion",
	"fechada": "close",
	"fechadas": "close",
	"Gestor": "Manager",
	"Interna": "Internal",
	"Internas": "Internal",
	"Item da Auditoria": "Audit Item",
	"Itens da Auditoria": "Audit Itens",
	"Livre": "Free",
	"Livres": "Free",
	"Minhas auditorias": "My audits",
	"Não Conforme": "Non-Compliant",
	"Nenhuma Categoria de Não Conforme foi cadastrada": "No Non-Compliant Category was registered",
	"Nenhuma Categoria de Oportunidade de Melhoria foi cadastrada": "No Improvement Opportunity Category has been registered",
	"Nenhuma Categoria de Observação foi cadastrada": "No Observation Category has been registered",
	"Nome Usuário é requerido": "Username is required",
	"Norma": "Standard",
	"Nova auditoria": "New audit",
	"Oportunidade de Melhoria": "Improvement opportunity",
	"Painel de Auditorias": "Audits Panel",
	"Painel de auditorias": "Audits panel",
	"Participante Externo": "External Participant",
	"Participante Externo é requerido": "External Participant is required",
	"Participantes não podem ser repetidos": "Participants cannot be repeated",
	"Participantes externos não podem ser repetidos": "External participants cannot be repeated",
	"Participantes": "Participants",
	"Selecionar Itens da Norma": "Select Standard Items",
	"Título da auditoria não confere": "Audit title does not match",
	"Título deve conter no máximo 200 caracteres": "Title must contain a maximum of 200 characters",
	"Todas as auditorias": "All audits",
	"Visualizar Auditoria": "View Audit",
	"Você deve selecionar uma norma primeiro": "You must select a standard first"
};

export default ENAuditsPanel;
